import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getMyLostItemCases, lostItemStatusBadge } from '../../services/disputeService';
import toast from 'react-hot-toast';
import BackButtonBottom from '../../components/common/BackButtonBottom';

export default function MyLostItems() {
  const navigate = useNavigate();
  const { userProfile } = useAuth();
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userProfile?.id) return;
    getMyLostItemCases(userProfile.id, 'rider')
      .then(setCases)
      .catch((err) => toast.error(err.message || 'Could not load cases'))
      .finally(() => setLoading(false));
  }, [userProfile?.id]);

  const fmtDate = (ts) => {
    if (!ts) return '';
    const d = ts._seconds ? new Date(ts._seconds * 1000) : new Date(ts);
    return isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  return (
    <div className="max-w-[700px] mx-auto p-6">
      <div className="mb-4">
        <button onClick={() => navigate('/rider')} className="bg-transparent border-0 text-brand-primary font-semibold text-[0.9rem] cursor-pointer p-0">← Dashboard</button>
      </div>

      <h1 className="font-serif mt-0 mb-2">My lost items</h1>
      <p className="text-body text-[0.9rem] mb-6">
        Lost item reports you've filed.
      </p>

      <button onClick={() => navigate('/rider/report-lost-item')} className="w-full p-3 rounded-xl border-[1.5px] border-dashed cursor-pointer font-semibold mb-4"
        style={{ borderColor: '#2dd4a8', background: '#f0fdfa', color: '#0a8270' }}>+ Report a lost item</button>

      {loading && <div className="p-10 text-center text-muted">Loading...</div>}

      {!loading && cases.length === 0 && (
        <div className="p-10 text-center text-muted bg-white rounded-2xl border border-slate-200">
          No lost item reports.
        </div>
      )}

      <div className="grid gap-3">
        {cases.map(c => {
          const badge = lostItemStatusBadge(c.status);
          return (
            <div key={c.id} onClick={() => navigate(`/rider/lost-items/${c.id}`)} className="p-4 rounded-2xl bg-white border border-slate-200 cursor-pointer transition-all">
              <div className="flex justify-between items-start mb-1.5">
                <div className="font-bold text-brand-dark">{c.referenceNumber}</div>
                <span className="px-2.5 py-[3px] rounded-full text-[0.7rem] font-bold" style={{ background: badge.bg, color: badge.color }}>
                  {badge.label}
                </span>
              </div>
              <div className="text-[0.85rem] text-body mb-1">
                {c.description?.substring(0, 100)}{c.description?.length > 100 ? '...' : ''}
              </div>
              <div className="flex justify-between text-[0.78rem] text-muted">
                <span>Trip: {c.bookingReferenceNumber || c.bookingId?.substring(0, 8)}</span>
                <span>{fmtDate(c.createdAt)}</span>
              </div>
            </div>
          );
        })}
      </div>
    <BackButtonBottom to="/rider" label="Dashboard" />
    </div>
  );
}